/**
 * External dependencies
 */

/**
 * Internal dependencies
 */
import {
  SET_ACCOUNT_INITIALIZE,
  SET_ACCOUNT_LIST,
  SET_ACCOUNT_INFO
} from '@naruto/bgdcms/src/reducers/cores/account/actions';
import { errorCatch } from '@naruto/bgdcms/src/reducers/_Capture/errorCapture';
import {
  Dispatch,
  ThunkAction,
  Models,
  MiddleWare,
  AccountList,
  AccountListCondition,
  AccountListAPICondition,
  AccountInfo,
  AccountCreateData,
  AccountUpdateData
} from './types';

/* Initial */
/**
 * 初始化管理 store 資料
 */
export const postAccountInitialize =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(SET_ACCOUNT_INITIALIZE());
  };

/**
 * 取得帳號列表
 */
export const getAccountList =
  (condition: AccountListCondition): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.account.getAccountList<AccountList, AccountListAPICondition>(condition.api);
    if (!result.error && result.response) {
      dispatch(SET_ACCOUNT_LIST({ list: result.response, condition }));
    } else {
      const oldState = getState().account.accountList;
      if (oldState) {
        dispatch(
          SET_ACCOUNT_LIST({
            list: { ...oldState.content },
            condition: { ...oldState.condition }
          })
        );
      } else {
        dispatch(
          SET_ACCOUNT_LIST({
            list: {
              list: [],
              pager: {
                page: 1,
                page_size: 1,
                total_page: 1,
                total_count: 1
              }
            },
            condition: {
              api: {
                page: 1,
                page_size: 40,
                with_pager: false
              }
            }
          })
        );
      }
    }
    await dispatch(errorCatch(result.error, result.status));
  };
/**
 * 更新帳號列表查詢條件
 */
export const postAccountListCondition =
  (condition: AccountListCondition): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState): Promise<void> => {
    const oldState = getState().account.accountList;
    dispatch(SET_ACCOUNT_LIST({ list: { ...oldState.content }, condition }));
  };
/**
 * 取得帳號資訊
 */
export const getAccountInfo =
  (accountID: string): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.account.getAccountInfo<AccountInfo>(accountID);
    if (!result.error && result.response) {
      dispatch(SET_ACCOUNT_INFO({ accountID, accountInfo: result.response }));
    } else {
      const oldState = getState().account.accountInfos[accountID];
      if (oldState) {
        dispatch(SET_ACCOUNT_INFO({ accountID, accountInfo: { ...oldState } }));
      } else {
        dispatch(
          SET_ACCOUNT_INFO({
            accountID,
            accountInfo: {
              account: {
                id: accountID,
                username: '',
                password: '',
                ctime: '',
                mtime: ''
              }
            }
          })
        );
      }
    }
    await dispatch(errorCatch(result.error, result.status));
  };
/**
 * 建立帳號
 */
export const postAccount =
  (
    accountData: AccountCreateData,
    successCallback?: () => void,
    errorCallback?: () => void
  ): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.account.postAccount<AccountInfo, AccountCreateData>(accountData);
    if (!result.error && result.response) {
      if (successCallback) {
        successCallback();
      }
    }
    if (result.error && errorCallback) {
      errorCallback();
    }
    await dispatch(errorCatch(result.error, result.status));
  };
/**
 * 更新帳號
 */
export const putAccount =
  (
    accountID: string,
    accountData: AccountUpdateData,
    successCallback?: () => void,
    errorCallback?: () => void
  ): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.account.putAccount<AccountInfo, AccountUpdateData>(accountID, accountData);
    if (!result.error && result.response) {
      if (successCallback) {
        successCallback();
      }
    }
    if (result.error && errorCallback) {
      errorCallback();
    }
    await dispatch(errorCatch(result.error, result.status));
  };
/**
 * 刪除帳號
 */
export const deleteAccount =
  (
    accountID: string,
    successCallback?: () => void,
    errorCallback?: () => void
  ): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.account.deleteAccount<AccountInfo>(accountID);
    if (!result.error && result.response) {
      if (successCallback) {
        successCallback();
      }
    }
    if (result.error && errorCallback) {
      errorCallback();
    }
    await dispatch(errorCatch(result.error, result.status));
  };
